import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { MeetingDebug } from '@/features/meeting-debug';
import { userStore } from '@/stores/user.store';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/meeting-debug/')({
  validateSearch: z.object({
    meetingId: z.string().optional(),
  }).parse,
  beforeLoad() {
    if (userStore.isInternalUser) {
      return;
    }

    throw redirect({
      to: Routes.Chats as string,
      replace: true,
    });
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { meetingId } = Route.useSearch();

  return <MeetingDebug meetingId={meetingId} />;
}
